import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

const TONE_CLASSES = {
  neutral: "bg-inset text-fg-soft",
  accent: "bg-accent-weak text-accent-text",
  success: "bg-success-weak text-success",
  warning: "bg-warning-weak text-warning",
  danger: "bg-danger-weak text-danger",
} as const;

export type StatusTone = keyof typeof TONE_CLASSES;

/**
 * Pill de status/tipo semântico — o canônico do design system (cor =
 * estado/prioridade, nunca decoração). Tons disponíveis:
 * neutral/accent/success/warning/danger.
 *
 * `features/organizer/components/StatusBadge.tsx` tem uma implementação
 * equivalente (mesmo vocabulário de tons) que nasceu antes deste componente
 * existir em `components/`. O dono do domínio organizer deve migrar para
 * este quando restilizar as telas dele — não foi migrado aqui porque
 * `features/organizer/**` é território de outro agent.
 */
export function StatusBadge({ tone, children }: { tone: StatusTone; children: ReactNode }) {
  return (
    <span
      className={cn(
        "inline-flex w-fit shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        TONE_CLASSES[tone],
      )}
    >
      {children}
    </span>
  );
}
